import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';

export default function Alert(props) {
  const { show, severity, children } = props;
  return (
    <MuiAlert
      style={{ visibility: show ? 'visible' : 'hidden' }}
      elevation={6}
      variant="filled"
      severity={severity}
      children={children}
    />
  );
}
